<template>
  <v-bottom-sheet
    v-bind:value="showMessages"
    v-on:input="messages_reset"
    hide-overlay
    inset
  >
    <v-sheet class="pa-5">
      <v-alert
        v-for="(message, index) in messages_list"
        v-bind:key="`message-${index}`"
        v-bind:type="message.type"
        v-on:click="messages_reset"
        border="left"
        outlined
      >{{ message.text }}</v-alert>

      <div class="text-center">
        <v-btn v-on:click="messages_reset" fab small>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
    </v-sheet>
  </v-bottom-sheet>
</template>

<script>
import messages from '../mixins/messages';

export default {
  name: "Messages",

  mixins: [ messages ],

  computed: {
    showMessages: function() { return this.messages_list.length > 0; }
  },
};
</script>